export default __webpack_public_path__ + "static/media/creative-mob.1096d56a.png";